import { useFlags } from 'launchdarkly-react-client-sdk';
import { Link } from 'react-router-dom';
import { appRoutes } from '../../app-routes';
import type { LaunchDarklyFlags } from '../../types/launch-darkly';
import styles from './AiToolsTabs.module.css';

type AiToolsTabId = 'agents' | 'tools' | 'skills' | 'credentials';

interface AiToolsTab {
  id: AiToolsTabId;
  label: string;
  to: string;
  requiresFlag?: keyof LaunchDarklyFlags;
}

interface AiToolsTabsProps {
  active: AiToolsTabId;
}

const TABS: AiToolsTab[] = [
  { id: 'agents', label: 'Agents', to: appRoutes.AI_AGENTS },
  { id: 'tools', label: 'Tools', to: appRoutes.AI_TOOLS },
  {
    id: 'skills',
    label: 'Skills',
    to: appRoutes.AI_SKILLS,
    requiresFlag: 'enable-partner-skill-authoring',
  },
  { id: 'credentials', label: 'Credentials', to: appRoutes.AI_CREDENTIALS },
];

/** Top-level navigation between the Agents sections. */
export const AiToolsTabs = ({ active }: AiToolsTabsProps) => {
  const ld = useFlags<LaunchDarklyFlags>();
  const visibleTabs = TABS.filter(tab => !tab.requiresFlag || ld[tab.requiresFlag]);

  return (
    <nav className={styles.tabs} aria-label="AI Tools sections">
      {visibleTabs.map(tab => (
        <Link
          key={tab.id}
          to={tab.to}
          aria-current={active === tab.id ? 'page' : undefined}
          className={styles.tab}>
          {tab.label}
        </Link>
      ))}
    </nav>
  );
};
